var _desc, _defs, _line, _path, _path2, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar4White(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 31",
    x1: 0.5,
    y1: 5.5,
    x2: 15.5,
    y2: 5.5,
    stroke: "#4B6483",
    strokeOpacity: 1,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 304",
    d: "M14.43 2.63L1.63 2.63C1.04 2.63 0.56 3.11 0.56 3.7L0.56 15.43C0.56 16.02 1.04 16.5 1.63 16.5L14.43 16.5C15.02 16.5 15.5 16.02 15.5 15.43L15.5 3.7C15.5 3.11 15.02 2.63 14.43 2.63Z",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 304",
    d: "M1.63 2.63C1.04 2.63 0.56 3.11 0.56 3.7L0.56 15.43C0.56 16.02 1.04 16.5 1.63 16.5L14.43 16.5C15.02 16.5 15.5 16.02 15.5 15.43L15.5 3.7C15.5 3.11 15.02 2.63 14.43 2.63L1.63 2.63Z",
    stroke: "#4B6483",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line 32",
    x1: 3.5,
    y1: 0.5,
    x2: 3.5,
    y2: 2.5,
    stroke: "#4B6483",
    strokeOpacity: 1,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line 33",
    x1: 12.5,
    y1: 0.5,
    x2: 12.5,
    y2: 2.5,
    stroke: "#4B6483",
    strokeOpacity: 1,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line 34",
    x1: 8.5,
    y1: 0.5,
    x2: 8.5,
    y2: 2.5,
    stroke: "#4B6483",
    strokeOpacity: 1,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar4White);
export default __webpack_public_path__ + "static/media/calendar_4_white.fd2b8b03b7d49ccfb97af26ee7081cd4.svg";
export { ForwardRef as ReactComponent };